
  <style>
    .hero-image {
      position: relative;
      background-image: url('../assets/img/hero_image_XL.png');
      background-size: cover;
      background-position: center;
      height: 100vh;
    }
    .overlay-image {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
      height: auto;
    }
  </style>



<div class="hero-image image-fluid">
  <img src="assets/img/Ascendiun_White-XL.png" alt="Overlay" class="overlay-image image-fluid">
</div>

